import createVueComponent from '../createVueComponent';

const ShieldPlus = createVueComponent('ShieldPlusIcon', [
  ['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10', key: '1irkt0' }],
  ['path', { d: 'M8 11h8', key: 'vwpz6n' }],
  ['path', { d: 'M12 15V7', key: '1ycneb' }],
]);

export default ShieldPlus;
